import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppComponent } from './app.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { LoaderComponent } from './loader/loader.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ResultsComponent } from './results/results.component';
import { AuthGuard } from './auth/guard/auth.guard';
import { LoginComponent } from './auth/login/login.component';
import { MfaComponent } from './auth/mfa/mfa.component';
import { RegisterComponent } from './auth/register/register.component';
import { RedeemCodeComponent } from './redeem-code/redeem-code.component';
import { PlayComponent } from './play/play.component';
import { ResultsDetailedComponent } from './results-detailed/results-detailed.component';
import { ChangePasswordComponent } from './auth/change-password/change-password.component';
import { UpdateDetailsComponent } from './auth/update-details/update-details.component';
import { AdminComponent } from './admin/admin.component';
import { AuthAdminGuard } from './auth/guard/authAdmin.guard';

const routes: Routes = [
  {
    path: '',
    component: DashboardComponent,
    data: {
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
      pageTitle: 'My Library',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    data: {
      pageTitle: 'Login',
      showNavBar: true,
      hideFooterNav: true,
      hideTopNav: true,
      bgDark: true,
      fluidContainer: true,
    },
  },
  {
    path: 'mfa',
    component: MfaComponent,
    data: {
      pageTitle: 'Authenticator',
      showNavBar: false,
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
    },
  },
  {
    path: 'register',
    component: RegisterComponent,
    data: {
      showNavBar: true,
      subTitle: 'Register',
    },
  },
  {
    path: 'change-password',
    component: ChangePasswordComponent,
    canActivate: [AuthGuard],
    data: {
      hideSiebar: false,
      noContainer: true,
      bgDark: false,
      pageTitle: 'Change Password',
    },
  },
  {
    path: 'update-details',
    component: UpdateDetailsComponent,
    canActivate: [AuthGuard],
    data: { hideSiebar: false, pageTitle: 'Account' },
  },
  {
    path: 'redeem-code',
    component: RedeemCodeComponent,
    data: {
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
      subTitle: 'Redeem Code',
    },
  },
  {
    path: 'results/:sessionId',
    component: ResultsDetailedComponent,
    data: {
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
      pageTitle: 'My Result',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'results',
    component: ResultsComponent,
    data: {
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
      pageTitle: 'My Results',
    },
    canActivate: [AuthGuard],
  },

  {
    path: 'admin',
    component: AdminComponent,
    data: {
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
      pageTitle: 'Admin',
    },
    canActivate: [AuthAdminGuard],
  },
  {
    path: 'play/:hash',
    component: PlayComponent,
    data: {
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
      pageTitle: 'Play scenario',
    },
    canActivate: [AuthGuard],
  },
  {
    path: 'loader/:hash',
    component: LoaderComponent,
    data: {
      hideFooterNav: true,
      hideTopNav: true,
      hideSiebar: true,
      bgDark: true,
      fluidContainer: true,
      hideFooter: true,
      pageTitle: 'Play scenario',
    },
    canActivate: [AuthGuard],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
